import React, { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { db } from '../firebase/firebase';
import ReactDOMServer from 'react-dom/server';

export default function Post() {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const iframeRef = useRef(null);

    useEffect(() => {
        const postRef = ref(db, `posts/en/${id}`);
        onValue(postRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setPost({
                    id,
                    content: data.content,
                    timestamp: new Date(data.timestamp).toLocaleString()
                });
            }
        });
    }, [id]);

    useEffect(() => {
        if (iframeRef.current && post) {
            const document = iframeRef.current.contentDocument;

            // Add Quill styles and other required styles to the iframe's head
            const styleLink = document.createElement('link');
            styleLink.rel = 'stylesheet';
            styleLink.href = 'https://cdn.quilljs.com/1.3.7/quill.snow.css';
            document.head.appendChild(styleLink);

            const customStyles = document.createElement('style');
            customStyles.textContent = `
                .ql-align-center { text-align: center; }
                .ql-align-right { text-align: right; }
                .ql-align-justify { text-align: justify; }
                .ql-indent-1 { padding-left: 3em; }
                .ql-indent-2 { padding-left: 6em; }
                .ql-indent-3 { padding-left: 9em; }
                .ql-indent-4 { padding-left: 12em; }
                .ql-indent-5 { padding-left: 15em; }
                .ql-indent-6 { padding-left: 18em; }
                .ql-indent-7 { padding-left: 21em; }
                .ql-indent-8 { padding-left: 24em; }
            `;
            document.head.appendChild(customStyles);

            // Render post content in the iframe
            document.body.innerHTML = ReactDOMServer.renderToString(
                <div>
                    <div dangerouslySetInnerHTML={{ __html: post.content }}></div>
                </div>
            );

            // Adjust the iframe height dynamically
            setTimeout(() => {
                const height = document.body.scrollHeight;
                iframeRef.current.style.height = `${height + 10}px`;
            }, 100);
        }
    }, [post]);

    return (
        <div style={{ paddingTop: '80px' }}>
            <iframe
                ref={iframeRef}
                style={{ width: '100%', height: 'auto', minHeight: '100px' }}
                frameBorder={0}
            ></iframe>
        </div>
    );
}
